import LinkIcon from "@mui/icons-material/Link";
import DescriptionIcon from "@mui/icons-material/Description";
import PaymentsIcon from "@mui/icons-material/Payments";

const icons = {
    LinkIcon,
    DescriptionIcon,
    PaymentsIcon,
};

const reSentLink = {
    id: "network_resent_link",
    title: "Re-Sent Claim Links",
    type: "group",
    icon: icons.LinkIcon,
    children: [
        {
            id: "Customer_Form",
            title: "Customer Form",
            type: "item",
            url: "/Customer_Form",
            icon: icons.DescriptionIcon,
        },
        {
            id: "Payment_Link",
            title: "Payment Link",
            type: "item",
            url: "/Payment_Link",
            icon: icons.PaymentsIcon,
        },
    ],
};

export default reSentLink;